import React from 'react';
import { Box } from '@mui/material';

import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import FileSearchPanel from '../../components/common/file/FileSearchPanel';

/**
 * 파일 찾기.
 *
 * 영업 · 제조 어디서 올렸든 한자리에서 찾는다.
 * 화면 알맹이는 FileSearchPanel 이고, 채팅에서도 같은 것을 쓴다.
 */
const FileSearchPage = () => (
  <div>
    <BreadcrumbsContainer title="공통관리/파일 찾기" icon="common" />
    <Box sx={{ m: 1 }}>
      <FileSearchPanel />
    </Box>
  </div>
);

export default FileSearchPage;
